import React from "react";

const NarrativeTitle = ({ title, text }) => {
  return (
    <div id="narrativeTitle" className="narrative-container">
      <div className="title-container">
        <p> {title} </p>
      </div>
      <div className="subhead-container">
        <h2> {text} </h2>
      </div>
      <style jsx>{`
        .narrative-container {
          width: 100%;
          color: white;
        }

        .narrative-container h2 {
          color: white;
          font-weight: 400;
          font-family: Neue Montreal, -apple-system, Roboto, Helvetica,
            sans-serif;
          margin-top: 0px;
        }

        .title-container {
          display: block;
          margin: auto;
          text-align: center;
          letter-spacing: -0.31px;
          text-transform: uppercase;
          font: 500 18px Clash Display, -apple-system, Roboto, Helvetica,
            sans-serif;
        }

        .subhead-container {
          display: block;
          margin: auto;
          text-align: center;
          font-size: 40px;
          font-family: Neue Montreal, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
      `}</style>
    </div>
  );
};

export default NarrativeTitle;
